// This file is auto-generated by @oracle/oraclejet-icu-l10n from src/resources/icu/bundle.json
// and should not be edited by hand. Update the JSON file and rerun the build to regenerate this content.

const bundle = {
  accAnnounceMovedKey: (p: { itemKey: string; position: string; referenceKey: string }) =>
    'Перемещено ' + p['itemKey'] + ' ' + p['position'] + ' ' + p['referenceKey'] + '.',
  accCommandKey: () => 'Команда',
  accControlKey: () => 'Закрыть',
  accPositionAfter: () => 'после',
  accPositionBefore: () => 'до',
  accReorderInstructions: (p: { keyPressed: string }) =>
    'Нажмите и удерживайте клавиши ' +
    p['keyPressed'] +
    ' и Shift, а затем воспользуйтесь клавишами со стрелками для изменения порядка.',
  calendarDateConverter_parseError: (p: { dateExample: string }) =>
    'Укажите полную дату, как в этом примере: ' + p['dateExample'] + '.',
  calendarMonthConverter_parseError: (p: { dateExample: string }) =>
    'Укажите месяц и год, как в этом примере: ' + p['dateExample'] + '.',
  chart_labelGroup: () => 'Группа',
  chart_labelSeries: () => 'Серия',
  chart_labelValue: () => 'Значение',
  checkboxSet_requiredMessageDetail: () => 'Обязательно',
  checkbox_requiredMessageDetail: () => 'Обязательно',
  close: () => 'Закрыть',
  collection_noData: () => 'Нет данных для отображения.',
  collection_selectAllRows: () => 'Выбрать все строки',
  collection_selectRow: (p: { ROW_NAME: string }) => 'Выбрать строку ' + p['ROW_NAME'],
  collection_sortDisabled: () => 'Сортировка невозможна',
  collection_sortEnabled: () => 'Доступно для сортировки',
  confirmation: () => 'Подтверждение',
  datePicker_currentDate: () => 'Текущая дата',
  datePicker_goToToday: () => 'Перейти к текущему дню',
  datePicker_label: () => 'Выбор даты',
  datePicker_month: () => 'Месяц',
  datePicker_months: () => 'Месяцы',
  datePicker_next: () => 'Далее',
  datePicker_nextDecade: () => 'Следующая декада',
  datePicker_nextMonth: () => 'Следующий месяц',
  datePicker_prev: () => 'Назад',
  datePicker_prevDecade: () => 'Предыдущая декада',
  datePicker_prevMonth: () => 'Предыдущий месяц',
  datePicker_restricted: () => 'Запрещено',
  datePicker_selected: () => 'Выбрано',
  datePicker_today: () => 'Сегодня',
  datePicker_weekNum: (p: { NUM: string }) => 'Неделя ' + p['NUM'],
  datePicker_weekNumColLabel: () => 'Номер недели',
  datePicker_year: () => 'Год',
  datePicker_years: () => 'Годы',
  error: () => 'Ошибка',
  expandableList_expandCollapseInstructionText: () =>
    'Для развертывания и свертывания используйте клавиши со стрелками',
  expandableList_groupCollapse: () => 'Свернуто',
  expandableList_groupExpand: () => 'Развернуто',
  filePicker_addFiles: () => 'Добавить файлы',
  filePicker_dropzonePrimaryText: () => 'Добавьте файлы',
  filePicker_dropzoneSecondaryText: () => 'Выберите или перетащите файл сюда',
  filePicker_dropzoneSecondaryTextMultiple: () => 'Выберите или перетащите файлы сюда',
  filePicker_multipleFileTypeUploadError: (p: { fileTypes: string }) =>
    'Невозможна загрузка файлов следующих типов: ' + p['fileTypes'],
  filePicker_singleFileUploadError: () => 'Загружайте по одному файлу за один раз',
  filePicker_singleTypeUploadError: (p: { fileType: string }) =>
    'Загрузка файлов типа ' + p['fileType'] + ' невозможна',
  filePicker_unknownFileTypeUploadError: () => 'неизвестно',
  formControl_clear: () => 'Очистить',
  formControl_day: () => 'День',
  formControl_helpAvailable: () => 'Доступна справка',
  formControl_hide: () => 'Скрыть',
  formControl_limitReached: (p: { CHARACTER_LIMIT: number }) =>
    'Достигнут лимит в ' +
    ((
      {
        one: new Intl.NumberFormat('ru').format(p['CHARACTER_LIMIT']) + ' символ',
        few: new Intl.NumberFormat('ru').format(p['CHARACTER_LIMIT']) + ' символа',
        many: new Intl.NumberFormat('ru').format(p['CHARACTER_LIMIT']) + ' символов'
      } as Partial<Record<Intl.LDMLPluralRule, string>>
    )[new Intl.PluralRules('ru').select(p['CHARACTER_LIMIT'])] ||
      new Intl.NumberFormat('ru').format(p['CHARACTER_LIMIT']) + ' символов') +
    '.',
  formControl_loading: () => 'Загрузка',
  formControl_maxLength: (p: { MAX_LENGTH: string }) =>
    'Можно ввести до ' + p['MAX_LENGTH'] + ' символов.',
  formControl_maxLengthRemaining: (p: { CHARACTER_COUNT: string }) =>
    'Осталось символов: ' + p['CHARACTER_COUNT'] + '.',
  formControl_month: () => 'Месяц',
  formControl_readOnly: () => 'Только для чтения',
  formControl_requiredMessageDetail: () => 'Введите значение.',
  formControl_show: () => 'Показать',
  formControl_year: () => 'Год',
  gantt_labelDate: () => 'Дата',
  gantt_labelEnd: () => 'Окончание',
  gantt_labelLabel: () => 'Метка',
  gantt_labelRow: () => 'Строка',
  gantt_labelStart: () => 'Начало',
  indexer_disabledLabel: (p: { SECTION: string }) =>
    p['SECTION'] + '. Соответствующий раздел не найден.',
  indexer_keyboardInstructionText: () => 'Нажмите Enter, чтобы выбрать значение.',
  indexer_othersLabel: () => '#',
  indexer_separatorLabel: (p: { FROM_SECTION: string; TO_SECTION: string }) =>
    'С ' + p['FROM_SECTION'] + ' по ' + p['TO_SECTION'] + '.',
  indexer_touchInstructionText: () =>
    'Дважды коснитесь и удерживайте, чтобы перейти в режим жестов, затем перетащите вверх или вниз, чтобы изменить значение.',
  info: () => 'Информация',
  inputDateMask_date_cleared: () => 'Дата удалена',
  inputDateMask_dayPlaceholder: () => 'дд',
  inputDateMask_empty_segment: () => 'Пусто',
  inputDateMask_monthPlaceholder: () => 'мм',
  inputDateMask_yearPlaceholder: () => 'гггг',
  inputDatePicker_dateRangeOverflowMessageDetail: (p: { max: string }) =>
    'Введите дату не позже ' + p['max'] + '.',
  inputDatePicker_dateRangeUnderflowMessageDetail: (p: { min: string }) =>
    'Введите дату не ранее ' + p['min'] + '.',
  inputDatePicker_dateRestrictionMessageDetail: () => 'Введите доступную дату.',
  inputDatePicker_instruction: () => 'Для доступа к календарю нажмите Tab.',
  inputDatePicker_selectDate: () => 'Выбрать дату',
  inputMonthMask_dateRangeOverflowMessageDetail: (p: { max: string }) =>
    'Укажите месяц и год, которые наступают не позднее, чем ' + p['max'] + '.',
  inputMonthMask_dateRangeUnderflowMessageDetail: (p: { min: string }) =>
    'Укажите месяц и год, которые наступают не ранее, чем ' + p['min'] + '.',
  inputNumber_converterParseError: () => 'Введите число.',
  inputNumber_decrease: () => 'Уменьшить',
  inputNumber_increase: () => 'Увеличить',
  inputPassword_hidden: () => 'Пароль скрыт',
  inputPassword_hide: () => 'Скрыть пароль',
  inputPassword_show: () => 'Показать пароль',
  inputSensitiveText_hidden: () => 'Конфиденциальный текст скрыт',
  list_msgFetchCompleted: () => 'Загружено',
  list_msgFetchingData: () => 'Загрузка',
  list_suggestion: () => 'Предложение',
  messageToast_allMessagesClosed: () => 'Все всплывающие сообщения-подсказки закрыты.',
  message_close: () => 'Закрыть',
  message_confirmation: () => 'Завершено',
  message_error: () => 'Ошибка',
  message_info: () => 'Информация',
  message_navigationFromMessagesRegion: () =>
    'Вход в область сообщений. Нажмите F6 для возврата к предыдущему элементу в фокусе.',
  message_navigationToMessagesRegion: () =>
    'Область сообщений содержит новые сообщения. Нажмите F6 для перехода к последней области сообщений.',
  message_warning: () => 'Предупреждение',
  noData_message: () => 'Нет элементов для отображения',
  overflowItemLabel: () => 'Больше вкладок',
  plural_separator: () => ', ',
  progressIndeterminate: () => 'Выполняется',
  radio_helpForRadio: () => 'Справка по переключателю',
  radio_requiredMessageDetail: () => 'Выберите значение.',
  selectMultiple_apply: () => 'Применить',
  selectMultiple_back: () => 'Назад',
  selectMultiple_countPlus: (p: { COUNT: string }) => p['COUNT'] + '+',
  selectMultiple_highlightSelectedTagsInstructionText: () =>
    'Используйте клавиши со стрелками влево и вправо для выделения выбранных значений.',
  selectMultiple_removeSelectedTagInstructionText: () =>
    'Нажмите клавишу Backspace или Delete, чтобы удалить выбранное значение.',
  selectMultiple_selectedValues: () => 'Выбранные значения',
  selectMultiple_showSelectedValues: () => 'Показать только выбранные значения.',
  selectMultiple_valuesSelected: (p: { VALUE_COUNT: string }) =>
    'Выбрано значений: ' + p['VALUE_COUNT'] + '.',
  select_addToList: () => 'Добавить в список',
  select_addToListAvailable: () => 'Доступно "Добавить в список"',
  select_moreSearchOptions: () => 'Дополнительные параметры поиска',
  select_moreSearchOptionsAvailable: () => 'Доступны дополнительные параметры поиска',
  select_noMatchesFound: () => 'Совпадений не найдено.',
  select_oneMatchFound: () => 'Найдено одно совпадение',
  select_requiredMessageDetail: () => 'Выберите значение.',
  select_sizeMatchesFound: (p: { TOTAL_SIZE: string }) => 'Найдено совпадений: ' + p['TOTAL_SIZE'],
  select_sizeOrMoreMatchesFound: (p: { TOTAL_SIZE: string }) =>
    'Найдено совпадений: ' + p['TOTAL_SIZE'] + ' или более',
  selectorAll_deselectAll: () => 'Отменить выбор',
  selectorAll_selectAll: () => 'Выбрать все',
  selector_selected: () => 'Флажок установлен',
  selector_unselected: () => 'Флажок не установлен',
  tabBarNavigationList_removeCueText: () => 'Для удаления',
  timeComponent_tooltipZoomIn: () => 'Увеличить',
  timeComponent_tooltipZoomOut: () => 'Уменьшить',
  train_current: () => 'Текущий',
  train_message_type: () => 'Тип сообщения',
  train_not_visited: () => 'Не посещено',
  train_status: (p: { currentStep: string; numberOfSteps: string }) =>
    'Шаг ' + p['currentStep'] + ' из ' + p['numberOfSteps'],
  train_visited: () => 'Посещено',
  userAssistance_learnMore: () => 'Дополнительные сведения',
  userAssistance_required: () => 'Обязательно',
  vis_clearSelection: () => 'Отменить выбор',
  vis_drillable: () => 'С возможностью детализации',
  vis_labelAndValue: (p: { LABEL: string; VALUE: string }) => p['LABEL'] + ': ' + p['VALUE'],
  vis_labelCountWithTotal: (p: { itemCount: string; totalCount: string }) =>
    p['itemCount'] + ' из ' + p['totalCount'],
  vis_marqueeSelectTooltip: () => 'Выбор выделенной области',
  vis_marqueeZoomTooltip: () => 'Масштабирование выделенной области',
  vis_noData: () => 'Нет данных для отображения',
  vis_panTooltip: () => 'Сдвиг',
  vis_stateLoaded: () => 'Загружено',
  vis_stateLoading: () => 'Загрузка',
  vis_stateSelected: () => 'Выбрано',
  vis_stateUnselected: () => 'Не выбрано',
  warn: () => 'Предупреждение'
};
export default bundle;
